import Swiper from 'swiper/bundle'

/**
 * Slider component.
 * @author Dayne Coulson-Hoffacker
 */
export default class Slider {
  /**
   * Constructs a new Slider component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.swiperContainer = this.element.querySelector('.swiper-container')
    this.sliderPrevButton = this.element.querySelector('button.previous')
    this.sliderNextButton = this.element.querySelector('button.next')

    var slider = new Swiper(this.swiperContainer, {
      loop: true,
      slidesPerView: 1,
      autoHeight: true,
      watchOverflow: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction'
      }
    })

    this.sliderPrevButton.addEventListener('click', () => {
      slider.slidePrev()
    })

    this.sliderNextButton.addEventListener('click', () => {
      slider.slideNext()
    })

  }
}



// WEBPACK FOOTER //
// ./components/slider/index.js